import React, { FC } from 'react'

const VisaIcon: FC = () => (
  <svg width="24" height="8" viewBox="0 0 24 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.45382 7.47034L9.67023 0.128906H11.6117L10.3965 7.47034H8.45382Z"
      fill="#747796"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4426 0.309472C17.0598 0.161683 16.4548 0 15.7019 0C13.7819 0 12.4304 0.996625 12.419 2.42399C12.4064 3.47998 13.3841 4.06861 14.1192 4.4185C14.8771 4.7785 15.131 5.00839 15.1285 5.32923C15.1234 5.82186 14.5234 6.0467 13.9651 6.0467C13.1883 6.0467 12.7739 5.93554 12.1361 5.6627L11.886 5.54523L11.6144 7.18859C12.0678 7.39322 12.9066 7.57006 13.7794 7.5789C15.8194 7.5789 17.1457 6.59617 17.1609 5.07155C17.1697 4.23534 16.6506 3.59998 15.5289 3.07703C14.8506 2.73598 14.435 2.51114 14.4388 2.1663C14.4388 1.86188 14.7912 1.53473 15.5516 1.53473C16.187 1.52462 16.6468 1.66736 17.0055 1.81641L17.1798 1.90104L17.4426 0.309472Z"
      fill="#747796"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0308 4.86829C20.1912 4.4464 20.8038 2.81567 20.8038 2.81567C20.7925 2.83462 20.9643 2.38999 21.0615 2.11589L21.1929 2.74873C21.1929 2.74873 21.5668 4.50072 21.6426 4.86829H20.0308ZM22.4274 0.136455H20.9255C20.4606 0.136455 20.112 0.26656 19.9074 0.744031L17.0223 7.47409H19.0636C19.0636 7.47283 19.3958 6.56842 19.4716 6.36884C19.6952 6.36884 21.677 6.37389 21.96 6.37389C22.0181 6.63031 22.1962 7.47409 22.1962 7.47409H24L22.4274 0.136455Z"
      fill="#747796"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.82487 0.134991L4.92383 5.13959L4.7192 4.12276C4.36426 2.95055 3.26153 1.68109 2.02869 1.04193L3.76805 7.46505L5.82319 7.46252L8.88381 0.134991H6.82487Z"
      fill="#747796"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.15788 0.130145H0.025263L0 0.282987C2.43788 0.890562 4.04973 2.35813 4.7192 4.12276L4.03829 0.750352C3.92082 0.28425 3.57977 0.146566 3.15788 0.130145Z"
      fill="#747796"
    />
  </svg>
)

export default VisaIcon
